// extracted by mini-css-extract-plugin
module.exports = {"label":"a10a3f92e9--label--RwwuG"};